export default class RequestCancelledError extends Error {
    constructor(message: string) {
        super(message)
        Object.setPrototypeOf(this, RequestCancelledError.prototype)
    }
}
